import { defineComponent, openBlock, createBlock, unref, withCtx, createTextVNode } from 'vue';
import { Button } from '@ssml-editor/vue';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "full-screen-menu",
  props: {
    editor: {}
  },
  setup(__props) {
    function menuClickHandler() {
      if (__props.editor) {
        const htmlElement = __props.editor.htmlElement;
        if (htmlElement) {
          const fullScreenEditor = htmlElement.closest(".se-editor-full-screen");
          if (fullScreenEditor) {
            fullScreenEditor.classList.remove("se-editor-full-screen");
          } else {
            htmlElement.closest(".se-editor")?.classList.add("se-editor-full-screen");
          }
        }
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Button), {
        "icon-class": "iconfont-ssml-editor icon-ssml-editor-quanping",
        onClick: menuClickHandler
      }, {
        default: withCtx(() => [
          createTextVNode("全屏")
        ]),
        _: 1
      });
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=full-screen-menu.vue.js.map
